import type { MagazineAnalyticsSettingInput } from "@/lib/gql/__generated__/graphql";

import type { MagazineAnalyticsSettingFormModel } from "../../../../type";

type Props = {
	viewModel: MagazineAnalyticsSettingFormModel["ViewModel"];
};

export const viewModelToInput = ({ viewModel }: Props) => {
	const input: MagazineAnalyticsSettingInput = {
		hotelID: viewModel.hotelID,

		gtmID: viewModel.gtmID?.value,
		gtmAvailable: viewModel.gtmAvailable.value,

		pixelID: viewModel.pixelID?.value,
		pixelAvailable: viewModel.pixelAvailable.value,
	} satisfies MagazineAnalyticsSettingInput;

	return input;
};
